import { z } from 'zod';

import { zodCallOffResponseSchema } from '../validations';

// Request payload schema for requesting cancellation
export const zodRequestCancelPayloadSchema = z.object({
  notes: z.string().nullish(),
});

// Response schema (re-export from shared)
export { zodCallOffResponseSchema as zodRequestCancelResponseSchema };
